import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { AIIntegration } from 'devextreme/common/ai-integration';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AiIntegrationService {

  // One shared AIIntegration for every AI-enabled DevExtreme widget. The
  // widget builds the full prompt client-side and expects the model's raw
  // text back — sendRequest just proxies it through promoflo-api, which
  // holds the Anthropic key. fetch (not HttpClient) so the widget's abort
  // hook maps straight onto an AbortController.
  readonly integration: AIIntegration;

  constructor(private cookieService: CookieService) {
    this.integration = new AIIntegration({
      sendRequest: (params) => {
        const controller = new AbortController();
        const token = this.cookieService.get('otd-token-temp') || sessionStorage.getItem('token');
        const promise = fetch(`${environment.baseApiUrl}ai-assistant`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
          },
          body: JSON.stringify({
            system: params.prompt.system,
            user: params.prompt.user,
            // Grid commands ride outside the prompt: the widget expects the
            // provider to hand its response schema to the AI service. Without
            // it the model invents command names and the widget rejects the
            // reply as "Invalid response".
            response_schema: (params.data as any)?.responseSchema ?? null
          }),
          signal: controller.signal
        }).then(async (response) => {
          if (!response.ok) {
            throw new Error(`AI assistant request failed (${response.status})`);
          }
          const result = await response.json();
          return result.data.text;
        });
        return { promise, abort: () => controller.abort() };
      }
    });
  }
}
